import { Module } from 'vuex';
import { RootState } from '../store';
import { mutations } from '../mutations/session.mutations';
import { actions } from '../actions/session.actions';
import { getters } from '../getters/session.getters';
import { IUser } from '@/types/User';
import { ISession } from '@/types/Session';

export const namespace = 'session';

export interface SessionState {
  session: ISession;
  sessionIsLoading: boolean;
  sessionIsLoaded: boolean;
  token: string;
  user: IUser;
}

export const state: SessionState = {
  session: {},
  sessionIsLoading: false,
  sessionIsLoaded: false,
  token: null,
  user: {},
};

const namespaced: boolean = true;

export const session: Module<SessionState, RootState> = {
  actions,
  getters,
  namespaced,
  mutations,
  state,
};
